import {
  Component,
  signal,
  HostListener,
  ChangeDetectionStrategy,
  inject,
} from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { ButtonModule } from "primeng/button";
import {
  RouterModule,
  RouterLink,
  RouterLinkActive,
  Router,
} from "@angular/router";
import { CognitoService } from "../shared/services/cognito.service";
import { environment } from '../../environments/environment';

@Component({
  selector: "app-navbar",
  standalone: true,
  imports: [
    NgOptimizedImage,
    ButtonModule,
    RouterModule,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: "./navbar.component.html",
  styleUrl: "./navbar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  readonly isOpen = signal(false);
  private cognitoService = inject(CognitoService);
  private router = inject(Router);
  readonly isStaging = !environment.production;

  toggleMenu() {
    this.isOpen.update((v) => !v);
  }
  closeMenu() {
    this.isOpen.set(false);
  }

  async logout() {
    await this.cognitoService.signOut();
    await this.router.navigate(["/login"]);
  }

  @HostListener("document:keydown.escape")
  onEsc() {
    this.closeMenu();
  }

  @HostListener("window:resize")
  onResize() {
    if (window.innerWidth >= 768) this.isOpen.set(false);
  }
}
